import React from 'react';
import styled from 'styled-components';
import checkboxCheckedIcon from './checkbox-checked.svg';
import checkboxUncheckedIcon from './checkbox-unchecked.svg';

interface Props {
  label: string;
  checked: boolean;
}

const CheckboxGroupPdf: React.FC<Props> = ({ label, checked }) => {
  return (
    <>
      <Icon src={checked ? checkboxCheckedIcon : checkboxUncheckedIcon} />
      <label>{label}</label>
    </>
  );
};

export default CheckboxGroupPdf;

const Icon = styled.img`
  width: 8pt;
  height: 8pt;
  display: block;
  /* HACK: comment to #11660 - despite "align-items: center", the checkbox isn't centered enough... */
  transform: translateY(-0.75pt);
`;
